import React, { useState } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import DeleteIcon from "@mui/icons-material/Delete";

import { getImage } from "../../utils/images";
import ConfirmDeleteModal from "../../components/images/ConfirmDeleteModal";

const AssetItem = ({
  currentAsset,
  setCurrentAsset,
  onRemove,
  onOpenImageModal,
  asset,
  selectedImage,
  onSelectImage,
}) => {
  const [deleteAsset, setDeleteAsset] = useState(false);
  const theme = useTheme();

  const handleDelete = () =>
    onRemove({
      variables: {
        id: asset.id,
        projectId: asset.projectId,
      },
    });

  const handleToggleConfirmDeleteModal = () => setDeleteAsset(v => !v);

  const isSelected = currentAsset.id === asset.id;

  const styles = {
    root: {
      height: 36,
      paddingTop: 0,
      paddingBottom: 0,
      border: isSelected ? `2px solid ${theme.palette.primary.main}` : undefined,
      "&:hover": {
        border: isSelected ? `2px solid ${theme.palette.primary.main}` : undefined,
      },
    },
    imageContainer: {
      display: "flex",
      overflow: "auto",
      "-ms-overflow-style": "none",
    },
    getImage: isActive => ({
      border: isActive ? `1px solid ${theme.palette.primary.main}` : "1px solid white",
      maxHeight: "30px",
    }),
  };

  return (
    <>
      <Box mt={1}>
        <Button
          id={`assetItem-${asset.id}`}
          fullWidth
          variant="outlined"
          onClick={() => setCurrentAsset(asset)}
          sx={styles.root}
        >
          <Grid container spacing={1} alignItems="center">
            <Grid container wrap="nowrap" justifyContent="flex-start" size={6}>
              {asset.originRoomNumber} | {asset.originEmployeeName}
            </Grid>
            <Grid container wrap="nowrap" justifyContent="flex-end" alignItems="center" size={6}>
              <Box data-id="asset-images" mr={1.5} sx={styles.imageContainer}>
                {asset.images.map((image, index) => (
                  <Box
                    component="img"
                    mr={0.5}
                    key={index}
                    borderRadius={4}
                    src={getImage(image.url)}
                    onClick={e => {
                      e.stopPropagation();
                      setCurrentAsset(asset);
                      onSelectImage(image.id);
                      onOpenImageModal(asset.id);
                    }}
                    sx={styles.getImage(selectedImage === image.url)}
                  />
                ))}
              </Box>
              <IconButton
                data-id="delete-asset-row"
                component="div"
                onClick={handleToggleConfirmDeleteModal}
              >
                <DeleteIcon color="action" />
              </IconButton>
            </Grid>
          </Grid>
        </Button>
      </Box>
      {deleteAsset && (
        <ConfirmDeleteModal
          title="Delete Asset"
          descr="Are you sure you want to delete asset?"
          onClose={handleToggleConfirmDeleteModal}
          onDelete={handleDelete}
        />
      )}
    </>
  );
};

export default React.memo(AssetItem);
